import { useEffect } from 'react';
import { useSelector } from 'react-redux';

/** 浅色模式在 <html> 挂 home-chrome-plan-b，供顶栏/快速入口/统一浅色画布样式 */
export function useHomeChromeDocumentClass() {
	const isDark = useSelector((state) => state.config?.isDark);

	useEffect(() => {
		const root = document.documentElement;
		const light = !isDark;

		root.classList.toggle('home-chrome-plan-b', light);

		return () => {
			root.classList.remove('home-chrome-plan-b');
		};
	}, [isDark]);
}
